// import axios from "axios";

const response = [
  {
    id: 1,
    candidateName: 'Amitha Perera',
    relocation: '../img/candidates-icons/relocate_icon.svg',
    location: 'Sofia',
    empType: '../img/candidates-icons/emplyment-type-icons/freelance_icon.svg',
    updated: '26-06-19',
    skills: [
      { name: 'Javascript', icon: '../img/candidates-icons/tech_icons/javascript-original.svg' },
      { name: 'Node.js', icon: '../img/candidates-icons/tech_icons/nodejs-original.svg' },
      { name: 'React', icon: '../img/candidates-icons/tech_icons/react-original.svg' },
    ],
    recentActivity: 'No Contact',
    recentPosition: 'JavaScript Developer',
    recentCompany: 'Sigma Technology AB',
  },
  {
    id: 2,
    candidateName: 'Ivan Ivanov',
    relocation: '../img/relocate_icon.svg',
    location: 'Sofia',
    empType: '../img/candidates-icons/emplyment-type-icons/freelance_icon.svg',
    updated: '26-06-19',
    skills: [
      { name: 'Javascript', icon: '../img/candidates-icons/tech_icons/javascript-original.svg' },
      { name: 'Node.js', icon: '../img/candidates-icons/tech_icons/nodejs-original.svg' },
      { name: 'React', icon: '../img/candidates-icons/tech_icons/react-original.svg' },
    ],
    recentActivity: 'Not suitable',
    recentPosition: 'JavaScript Developer',
    recentCompany: 'Comstream AB',
  },
  {
    id: 3,
    candidateName: 'Petar Ivanov',
    relocation: null,
    location: 'Sofia',
    empType: '../img/candidates-icons/emplyment-type-icons/freelance_icon.svg',
    updated: '26-06-19',
    skills: [
      { name: 'Javascript', icon: '../img/candidates-icons/tech_icons/javascript-original.svg' },
      { name: 'Node.js', icon: '../img/candidates-icons/tech_icons/nodejs-original.svg' },
      { name: 'React', icon: '../img/candidates-icons/tech_icons/react-original.svg' },
    ],
    recentActivity: 'Placed',
    recentPosition: 'Java Developer',
    recentCompany: 'Comstream AB',
  },
  {
    id: 4,
    candidateName: 'Milen Denchev',
    relocation: '../img/relocate_icon.svg',
    location: 'Sofia',
    empType: '../img/candidates-icons/emplyment-type-icons/freelance_icon.svg',
    updated: '26-06-19',
    skills: [
      { name: 'Javascript', icon: '../img/candidates-icons/tech_icons/javascript-original.svg' },
      { name: 'Node.js', icon: '../img/candidates-icons/tech_icons/nodejs-original.svg' },
      { name: 'React', icon: '../img/candidates-icons/tech_icons/react-original.svg' },
    ],
    recentActivity: 'Contacted',
    recentPosition: 'IGaming Support Professional',
    recentCompany: 'Blue Coral Solutions',
  },
];

const state = {
  candidatesList: [],
  candidateItem: null,
};

const getters = {
  getCandidatesList: state => state.candidatesList,
};

const actions = {
  async fetchCandidatesList({ commit }) {
    commit('setCandidatesList', response);
  },
};

const mutations = {
  setCandidatesList: (state, candidatesList) => (state.candidatesList = candidatesList),
};

export default {
  state,
  actions,
  getters,
  mutations,
};
